import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs";
import {contextPath} from "site";
import {OrgService} from "../shared/org.service";
import {UnattachedPurchase} from "./unattached-purchase";

const apiURL = `${contextPath}/api/purchase-attachment`;

@Injectable()
export class AvdbAttachmentService {
	constructor(
		private http: Http,
		private orgService: OrgService
	) {}

	getAttachmentOptions(): Observable<Array<UnattachedPurchase>> {
		return this.http.get(`${apiURL}/`, {headers: this.orgService.contextHeader})
			.map(response => {
				return response.json().map((r: any) => UnattachedPurchase.fromJSON(r));
			});
	}

	getAttachmentOptionsForDevice(deviceID: number): Observable<Array<UnattachedPurchase>> {
		const url = `${apiURL}/device/${deviceID}/`;
		return this.http.get(url, {headers: this.orgService.contextHeader})
			.map(response => {
				return response.json().map((r: any) => UnattachedPurchase.fromJSON(r));
			});
	}

	getAttachmentOptionsForAircraft(aircraftID: string): Observable<Array<UnattachedPurchase>> {
		const url = `${apiURL}/aircraft/${aircraftID}/`;
		return this.http.get(url, {headers: this.orgService.contextHeader})
			.map(response => {
				return response.json().map((r: any) => UnattachedPurchase.fromJSON(r));
			});
	}

	attachDevice(deviceID: number, partKey: string) {
		const url = `${apiURL}/device/${deviceID}/attach/${partKey}/`;
		const body = {};
		return this.http.post(url, body, {headers: this.orgService.contextHeader});
	}

	attachAircraft(aircraftID: string, partKey: string) {
		const url = `${apiURL}/aircraft/${aircraftID}/attach/${partKey}/`;
		const body = {};
		return this.http.post(url, body, {headers: this.orgService.contextHeader});
	}
}

